// extracted by mini-css-extract-plugin
export default {"tooltip":"Jx-z","arrow":"Kx-z"};